import { useTitle } from "../../hooks/useTitle";

export const Medications = () => {
  useTitle("Medications");
  return <>Medications component</>;
};
